/*Response Format :
const jsonString = `{
    "message":"asd",
    "data":[],
    "timestamp":"",
    "encrypted":"false"
    "key":null
}`;
*/
import CryptoJS from "crypto-js"; 

//getMessage(jsonString);
function getMessage(jsonStr) {
    try {
        const parsedData = JSON.parse(jsonStr);
        return parsedData.message;
    } catch (error) {
        console.error("Invalid JSON string provided:", error);
        return null;
    }
}

//getData(jsonStr);
function getData(jsonStr) {
    try {
        const parsedData = JSON.parse(jsonStr);

        // 1. Check if the data is flagged as encrypted
        if (parsedData.encrypted === "true") {
            const encryptedBase64 = parsedData.data; 
            const secretKey = parsedData.key; // Fetch the key directly from the response

            if (!encryptedBase64 || typeof encryptedBase64 !== "string") {
                throw new Error("No valid encrypted string found in 'data'.");
            }

            if (!secretKey) {
                throw new Error("Data is marked encrypted, but 'key' is missing or null.");
            }

            // 2. Decode the combined Base64 string into a CryptoJS WordArray
            const combinedWords = CryptoJS.enc.Base64.parse(encryptedBase64);
            
            // AES initialization vector is always 16 bytes
            const ivSizeBytes = 16; 
            
            // 3. Slice out the IV (16 bytes = 4 words in CryptoJS)
            const ivWords = CryptoJS.lib.WordArray.create(
                combinedWords.words.slice(0, ivSizeBytes / 4)
            );
            
            // 4. Slice out the remaining ciphertext payload
            const ciphertextWords = CryptoJS.lib.WordArray.create(
                combinedWords.words.slice(ivSizeBytes / 4)
            );
            const ciphertextBase64 = CryptoJS.enc.Base64.stringify(ciphertextWords);

            // 5. Parse the dynamic secret key string
            const key = CryptoJS.enc.Utf8.parse(secretKey); 

            // 6. Decrypt the payload
            const decrypted = CryptoJS.AES.decrypt(
                ciphertextBase64, 
                key, 
                {
                    iv: ivWords,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );

            // 7. Convert decrypted bytes back into a readable UTF-8 string
            const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
            
            if (!plaintext) {
                throw new Error("Decryption failed. The provided key might be incorrect.");
            }

            // 8. Try parsing the plaintext as JSON if it's an object/array payload
            try {
                return JSON.parse(plaintext);
            } catch {
                return plaintext; 
            }
        } else {
            return parsedData.data;
        }

    } catch (error) {
        console.error("Error processing data:", error.message);
        return null;
    }
}

function isEncrypted(jsonStr) {
    try {
        const parsedData = JSON.parse(jsonStr);
        
        // Convert the string "false" or "true" to an actual boolean
        return parsedData.encrypted === "true";
    } catch (error) {
        console.error("Invalid JSON string provided:", error);
        return false;
    }
}

export { getMessage, getData, isEncrypted }; 